// extracted by mini-css-extract-plugin
module.exports = {"targetArea":"_2BJ6LgJD","targetAreaIcon":"_2d2UzFIe","targetAreaList":"c-do8pBA","targetAreaText":"_3bDczibx","toggleTargetArea":"ZegXEcTX","remainingCount":"_2K6hj8gW"};